import { useRef } from 'react';
import { useIsomorphicLayoutEffect } from '../../../core/hook/useIsomorphicLayout';
import { CustomCmsSeller } from '../../../domain/seller';
import { storeInformationGetMapEl } from './helpers';

const buildDirectionRouteNaverMap = (
  seller: CustomCmsSeller,
  origin: { latitude: number; longitude: number },
) => {
  const urlNaverMap = `https://map.naver.com/v5/directions/${origin.latitude},${origin.longitude}/${seller.latitude},${seller.longitude}`;
  return urlNaverMap;
};

const buildMarkerRouteNaverMap = (seller: CustomCmsSeller) => {
  const urlNaverMap = `https://map.naver.com/v5/directions/0,0/${seller.latitude},${seller.longitude}`;
  return urlNaverMap;
};

const seeItinerary = (seller: CustomCmsSeller) => {
  navigator.geolocation.getCurrentPosition(
    (geolocationPosition) => {
      // If we have geo coordinates of user, redirect to Naver Map with directions
      const { latitude, longitude } = geolocationPosition.coords;
      const urlNaverMap = buildDirectionRouteNaverMap(seller, { latitude, longitude });
      window.open(urlNaverMap);
    },
    () => {
      // If we don't have geo coordinates of user, redirect to Naver Map with seller marker only
      const urlNaverMap = buildMarkerRouteNaverMap(seller);
      window.open(urlNaverMap);
    },
  );
};

const initMarkerOnMap = (coords: { lat: number; lng: number }, map?: naver.maps.Map) => {
  const { lat, lng } = coords;

  return new naver.maps.Marker({
    position: new naver.maps.LatLng(lat, lng),
    map,
    icon: {
      url: '/assets/img/map/marker/marker_01.png',
    },
  });
};

const useStoreInformationNaverMap = (seller: CustomCmsSeller) => {
  // Naver Map
  const mapRef = useRef<naver.maps.Map>();
  // Marker of seller on Naver Map
  const markerSellerRef = useRef<naver.maps.Marker>();

  useIsomorphicLayoutEffect(() => {
    const mapEl = storeInformationGetMapEl();

    if (!mapEl) {
      return;
    }

    if (!mapRef.current) {
      // Initialize Naver Map
      mapRef.current = new naver.maps.Map(mapEl, {
        center: new naver.maps.LatLng(Number(seller.latitude), Number(seller.longitude)),
        zoom: 15,
        zoomControl: false,
        scaleControl: false,
        logoControl: false,
        mapTypeControl: false,
      });

      // Initialize Marker on Naver Map for Store
      markerSellerRef.current = initMarkerOnMap(
        {
          lat: Number(seller.latitude),
          lng: Number(seller.longitude),
        },
        mapRef.current,
      );
    }
  }, [seller]);

  return {
    mapRef,
    seeItinerary,
    defaultIniteraryLink: buildMarkerRouteNaverMap(seller),
  };
};

export default useStoreInformationNaverMap;
